import { DEFAULT_MESSAGE } from "./response_code_pipe.strings";

/**
 * Service to return a user-readable message from an object, given an error code.
 *
 * If the error code is not in the passed argument, or is undefined, a default
 * message will be returned.
 *
 * @param responseCode {number} - The code to be interpreted.
 * @param codeMessageObj {object} - An object matching codes (keys) and user
 * readable messages (values).
 */
export const responseCodePipe = (
    responseCode: number,
    codeMessageObj: object
) => {
    return codeMessageObj[responseCode] || DEFAULT_MESSAGE;
};
